import { useMemo } from "react"
import { useTranslation } from 'react-i18next'
import { Masonry } from "masonic"
import { useArtists } from "@/hooks/useArtists"
import { getUniqueArtists } from "@/lib/tattooData"
import { FotwCard } from "@/components/fotw/FotwCard"
import type { PortfolioItem } from "@/types/models"

interface FotwGalleryProps {
  items: PortfolioItem[]
  weekIndex: number
  votingEnded?: boolean
}

export function FotwGallery({ items, weekIndex, votingEnded }: FotwGalleryProps) {
  const { t } = useTranslation()

  const uniqueArtistIds = useMemo(() => getUniqueArtists(items), [items])
  const { artists } = useArtists(uniqueArtistIds)

  const renderItem = ({ data }: { data: PortfolioItem; index: number }) => {
    const artist = artists.find(a => a.id === data.artistId)
    return (
      <div className="grid-item">
        <FotwCard item={data} artist={artist} weekIndex={weekIndex} votingEnded={votingEnded} />
      </div>
    )
  }

  if (items.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <div className="text-lg font-medium text-foreground mb-2">
          {t('fotw.noResults.title')}
        </div>
        <div className="text-sm text-muted-foreground">
          {t('fotw.noResults.description')}
        </div>
      </div>
    )
  }

  return (
    <div className="w-full pb-8">
      <Masonry
        items={items}
        columnCount={2}
        columnGutter={12}
        rowGutter={8}
        render={renderItem}
        key={`fotw-gallery-${items.length}-${weekIndex}`}
      />
    </div>
  )
} 